import React from 'react'
import classnames from 'classnames'

export const Competitor = ({
  abbrev = '',
  scoreMarkupMobile = '',
  team = 'home'
}) => {
  return (
    <li className={`cscore__item cscore__item--${team}`}>
      <div className="cscore__name">{abbrev}</div>
      <div className="cscore__score" dangerouslySetInnerHTML={{ __html: scoreMarkupMobile }}/>
    </li>
  )
}

export const ScoreCell = ({
  gameState,
  header      = '',
  time        = '',
  date        = '',
  teams       = {},
  sport       = '',
  className   = '',
  summaryText = '',
  winnerClassFeature = '',
  homeTeamBattedFirst = true,
  showGameDetailFooter,
  currentPageLink = '#'
}) => {
  let team1 = homeTeamBattedFirst ? teams.home : teams.away
  let team2 = homeTeamBattedFirst ? teams.away : teams.home

  return (
    <div className="cricinfo__content__item">
      <div className={classnames('cscore', className, winnerClassFeature)}>
        <div className="cricinfo__type__link">
          <div className="cscore__overview">
            { (date || time) && 
              <div className="cscore__overview__title">{ gameState === 'pregame' ? date : time}</div>
            }
            { header && 
              <div className="cscore__overview__detail">{header}</div>
            }
          </div>
          <ul className="cscore__competitors">
            <Competitor team="home" {...team1} sport={sport} />
            <Competitor team="away" {...team2} sport={sport} />
          </ul>
          <div className="cscore__info">
            { (summaryText && showGameDetailFooter) ? summaryText : '' }
            { gameState === 'live' && 
              <div>
                <a href={currentPageLink} style={{ margin: '5px 0', 'display': 'inline-block', 'textDecoration': 'none' }}>
                  <img src="http://a.espncdn.com/i/cricinfo/refresh.gif" width="20" height="20" style={{ 'verticalAlign' : 'middle', marginRight: '10px' }}/>
                  <span>Refresh</span>
                </a>
              </div> 
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScoreCell



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/lite/ScoreCell.jsx
 **/